import { apiClient } from '../apiClient';
import { CreateUserDto, User } from './types';

export async function getUsers() {
  return await apiClient.get<User[]>('api/users');
}

export async function createUser(createUserDto: CreateUserDto) {
  return await apiClient.post<User>('api/users', createUserDto);
}

export async function deleteUser(id: number) {
  return await apiClient.delete<void>(`api/users/${id}`);
}
